import React from 'react';
import styled from 'styled-components';
import {FormattedMessage, injectIntl} from 'react-intl';
import {connect} from 'react-redux'
import H1 from "../../Components/H1";
import {ToolbarWithLogo} from '../../Components/Toolbar';
import ContainerPage from "../ContainerPage";
import {getSpecificOptions, registerWaitingListItem, resetWizard, toggleDayPart} from '../Welcome/Actions';
import {BottomWrapper, SelectViewWrapper, TopWrapper} from '../../Components/Layout';
import PoweredBy from "../../Components/PoweredBy";
import Select from "../../Components/Select";
import Sizes from "../../Assets/Sizes";
import FullPageLoader from "../../Components/FullPageLoader";
import {NavigationBottomButton} from "../../Components/NavigationButton";
import {humanizeDayOfWeek, serverDayDate, serverShortTime} from "../../Common/Helpers";
import ProgressTracker from "../../Components/ProgressTracker";
import H2 from "../../Components/H2";
import {CSSTransition} from "react-transition-group";
import Toast from "../../Components/Toast";
import Link from "../../Components/Link";
import AppointmentApprovalDialog from "../../Components/AppointmentApprovalDialog";
import {getSafely, isNonEmptyArray, isNonEmptyString, valueOrDefault} from "@tomeravni/easybizy-js-common/common";
import {PROGRESS_KEY, WAITING_LIST_PRESENTATION_MODE} from "../../Common/constants";
import {ColumnContainer} from "../Identify/CommonUI";
import WaitingListPopOver from "../../Components/WaitingListPopOver";


const MyTopWrapper = styled(TopWrapper)`
    .appear-enter {
        opacity: 0;
        transform: translateX(100%);
    }

    .appear-enter-active {
        opacity: 1;
        transform: translateX(0);
        transition: all 500ms ease-in;
    }
`;

const HH1 = styled(H1)`
    z-index: 1;
    text-align: center;
    width: 100%;
    padding-top: 0;
`;

const TimeOption = styled.div`
    display: flex;
    align-items: center;
`;
const Time = styled.div`
    font-size: 0.85em;
    // margin-left: 0.5em;
    margin-right: 0.5em;
`;

const NotFoundWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-left: ${Sizes.defaultPadding};
    padding-right: ${Sizes.defaultPadding};
    height: 100%;
    align-items: center;
    justify-content: center;
`;

const HH2 = styled(H2)`
    margin-bottom: ${Sizes.defaultPadding};
`;

const LoadMoreButton = styled(NavigationBottomButton)`
    margin-top: ${Sizes.defaultPadding};
    margin-bottom: ${Sizes.defaultPadding};
}`;


const MAX_RESULTS = 45;

class ResultsPage extends ContainerPage {
    state = {
        showWaitingListOptions: false
    };

    confirmAndCreateMeeting(option) {
        if (option.isWaitingListItem) {
            return this.presentWaitingListOptions();
        }

        const forcedRemarks = this.props.services.find(s => s.ForceRemarks) || {};
        this.confirmDialog.confirm(option, this.props.config.EnableRemarks,
            forcedRemarks.ForceRemarks, forcedRemarks.RemarksPlaceHolder).then((result) => this.done(result))
            .catch((err) => {
                let errorMessage = 'Unknown Error';
                if (err.message) {
                    try {
                        errorMessage = this.props.intl.formatMessage({id: err.message});
                    } catch (e) {
                        // Ignore
                    }
                }

                this.showToastMessage(errorMessage);
            });
    }


    componentDidMount() {
        super.componentDidMount();
        if (this.props.scheduledMeeting) {
            this.props.resetWizard();
            this.startOver();
        }
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        super.componentWillUpdate(nextProps, nextState, nextContext);
        if ((nextProps.services && nextProps.dayPart && nextProps.date) &&
            (!nextProps.loadingSpecificOptions && !nextProps.options && !this.specificOptionsError)) {
            this.loadOptions(nextProps);
            this.pageLoader.load();
        } else if (nextProps.options && !nextProps.loadingSpecificOptions) {
            this.pageLoader.done();
        } else if (nextProps.error) {
            this.pageLoader.error();
        }
    }

    loadOptions(props, date = null, loadMore = false) {
        let serviceIds = props.services.map(service => service.OnlineBookingServiceId).join(',');
        let employeeId = (props.config.AllowPickingEmployees && props.employee) ? props.employee.EmployeeId : null;

        this.props.getOptions(this.getCustomerToken(), serviceIds, employeeId,
            props.dayPart, date || props.date, loadMore, this.props.existingMode, props.gendersMap, props.quantityMap);
    }

    get userProps() {
        const props = this.props;
        let customer = getSafely(['config', 'Customer'], props)
        if (customer) {
            customer = {
                id: customer.CustomerId,
                name: customer.FullName || customer.FirstName,
                phoneNumber: customer.MobileFirst,
            }
        }

        return {
            services: props.services,
            employeeId: props.employeeId,
            dayPart: props.dayPart,
            customerToken: props.customerToken,
            gendersMap: props.gendersMap,
            quantityMap: props.quantityMap,
            customer
        }
    }

    loadMore() {
        if (!this.props.options) {
            return;
        }


        this.loadOptions(this.props, this.props.options[this.props.options.length - 1].Start, true)
    }

    successWaitingListRegistration() {
        this.navigate('/waiting-list/success', null, true);
    }

    adaptOption(option) {
        if (isNonEmptyString(option.label)) {
            return (<span>{option.label}</span>);
        }

        const employeeName = this.props.config.AllowPickingEmployees ?
            <span>,&nbsp;{option.EmployeeName}</span> : undefined;

        return <TimeOption>{humanizeDayOfWeek(option.Start)},&nbsp;
            <Time>{serverDayDate(option.Start)}{employeeName}</Time></TimeOption>
    }

    adaptSublabel(option) {
        if (option.isWaitingListItem) {
            return (<div></div>)
        }

        if (this.props.config?.HideServiceEndTime) {
            return <div>{serverShortTime(option.Start)}</div>
        }

        return <div>{serverShortTime(option.Start)} - {serverShortTime(option.End)}</div>
    }

    presentWaitingListOptions() {
        this.setState({showWaitingListOptions: true});
    }

    render() {
        const hasOptions = this.didMount && isNonEmptyArray(this.props.options);
        const noOptionsFound = !this.props.loadingSpecificOptions && this.props.options && this.props.options.length === 0;
        let maxedOutResults = this.props.options && this.props.options.length >= MAX_RESULTS;
        const currentProgressIndex = valueOrDefault(this.props.progress, []).findIndex((p) => p.label === PROGRESS_KEY.SERVICE) || 0;
        const ltr = !this.props.intl.locale.includes('he');
        const toolbarLogo = getSafely(['theme', 'properties', 'avatarImage'], window) || (this.props.config && this.props.config.Logo) || '';
        let optionsToPresent = [...valueOrDefault(this.props.options, [])];
        /// If waiting list is immediate mode (meaning the options we found are not actually close enough to the user request),
        if (hasOptions && this.props.waitingListMode === WAITING_LIST_PRESENTATION_MODE.IMMEDIATE) {
            optionsToPresent.unshift({
                Start: 'Waiting List', // This is a key, hence we set this.
                isWaitingListItem: true,
                label: this.props.intl.formatMessage({id: 'waiting_list'}),
            })
        }

        return (
            <div className="transition-item detail-page detail-page__results">
                <SelectViewWrapper padding={true} bottomPadding={false} loading={this.props.loading} ltr={ltr}>
                    <ToolbarWithLogo imageUri={toolbarLogo} ltr={ltr} rootUri={this.getRoutePrefix()}>
                        <ProgressTracker progress={this.props.progress} current={currentProgressIndex} visible={true}/>
                    </ToolbarWithLogo>

                    <MyTopWrapper justify="start" align="start" padding={true} preventFlex={true}
                                  className="page__content">
                        {!this.specificOptionsError &&
                            <HH1><FormattedMessage id="schedule.chooseASchedule"/></HH1>}
                        {hasOptions &&
                            <Select
                                ltr={ltr}
                                preventPaddingBottom={true}
                                selected={this.props.dateOption}
                                keyProp="Start"
                                onClick={(option) => this.confirmAndCreateMeeting(option)}
                                autoScrollNewPage={true}
                                darkenOptionsEvery={15}
                                items={optionsToPresent}
                                subLabalProp={(option) => this.adaptSublabel(option)}
                                nameProp={(option) => this.adaptOption(option)}>
                                {/*THIS IS CHILDREN COMPOSITION OPTION.*/}
                                <ColumnContainer>
                                    {this.props.waitingListMode === WAITING_LIST_PRESENTATION_MODE.SUGGESTION &&
                                        <LoadMoreButton className="secondary"
                                                        disabled={this.props.loadingSpecificOptions || maxedOutResults}
                                                        loading={this.props.loadingSpecificOptions.toString()}
                                                        onClick={() => this.presentWaitingListOptions()}
                                                        custom-theme="shallow-button"><FormattedMessage
                                            id="waiting_list"/>
                                        </LoadMoreButton>}
                                    <LoadMoreButton
                                        disabled={this.props.loadingSpecificOptions || maxedOutResults}
                                        loading={this.props.loadingSpecificOptions.toString()}
                                        onClick={() => this.loadMore()}
                                        custom-theme="shallow-button"
                                        icon="favorite"><FormattedMessage
                                        id={!maxedOutResults ? "schedule.loadMoreOptions" : "schedule.cannotloadMoreOptions"}/>
                                    </LoadMoreButton>
                                </ColumnContainer>


                            </Select>}
                        <CSSTransition
                            in={noOptionsFound}
                            unmountOnExit
                            timeout={1000}
                            classNames="appear">
                            <NotFoundWrapper>
                                <HH2><FormattedMessage id="schedule.notAppointmentsFound"/></HH2>
                                <NavigationBottomButton
                                    onClick={() => this.loadPreviousRoute()}
                                    custom-theme="shallow-button"
                                    icon="favorite"><FormattedMessage
                                    id="schedule.modifySearchRange"/></NavigationBottomButton>

                            </NotFoundWrapper>
                        </CSSTransition>

                        <CSSTransition
                            in={!!this.specificOptionsError}
                            unmountOnExit
                            timeout={1000}
                            classNames="appear">
                            <NotFoundWrapper>
                                <HH2>{this.specificOptionsError}</HH2>
                                <Link
                                    href={`tel:${this.props.config && this.props.config.BusinessPhoneNumber}`}><NavigationBottomButton
                                    custom-theme="shallow-button"
                                    icon="favorite"><FormattedMessage
                                    id="schedule.callUs"/></NavigationBottomButton></Link>

                            </NotFoundWrapper>
                        </CSSTransition>

                        <FullPageLoader ref={r => this.pageLoader = r}/>

                    </MyTopWrapper>
                    <BottomWrapper empty={true}>
                        <PoweredBy/>
                    </BottomWrapper>
                </SelectViewWrapper>
                <Toast ref={(toast) => this.toast = toast}/>
                <AppointmentApprovalDialog
                    innerRef={(confirmDialog) => this.confirmDialog = confirmDialog}/>
                <WaitingListPopOver
                    hidden={!this.state.showWaitingListOptions}
                    config={this.props.config}
                    timingOptions={this.props.timingOptions}
                    date={this.props.date}
                    toggleDayPart={this.props.toggleDayPart}
                    dayPart={this.props.dayPart}
                    daysOfWork={this.props.daysOfWork}
                    hide={() => this.setState({showWaitingListOptions: false})}
                    rangeType={this.props.waitingListRangeType}
                    selectedDate={this.props.waitingListSelectedDate}
                    selectedDaysOfWeek={this.props.waitingListSelectedDaysOfWeek}
                    onChangeRangeType={(rangeType) => this.props.setWaitingListRangeType(rangeType)}
                    onChangeSelectedDate={(selectedDate) => this.props.setWaitingListSelectedDate(selectedDate)}
                    onChangeSelectedDaysOfWeek={(daysOfWeek) => this.props.setWaitingListSelectedDaysOfWeek(daysOfWeek)}
                    onRegisterWaitingList={this.props.registerWaitingList}
                    registeringWaitingList={this.props.registeringWaitingList}
                    registeringWaitingListError={this.props.registeringWaitingListError}
                    waitingListItem={this.props.waitingListItem}
                    onSuccess={() => this.successWaitingListRegistration()}
                    userProps={this.userProps}
                ></WaitingListPopOver>
            </div>
        )
    }
}

/** Styled-Components **/

/** END OF Styled-Components **/

const mapStateToProps = state => {
    return {
        loading: state.schedule.fetchingConfig || state.schedule.fetchingServices,
        config: state.schedule.configWithServices,
        progress: state.schedule.progress,
        services: state.schedule.services,
        employee: state.schedule.employee,
        dayPart: state.schedule.stateParams ? state.schedule.stateParams.day_part : null,
        date: state.schedule.stateParams ? state.schedule.stateParams.date : null,
        loadingSpecificOptions: state.schedule.fetchingSpecificOptions,
        timingOptions: state.schedule.timingOptions,
        options: state.schedule.specificOptions,
        error: state.schedule.errorSpecificOptions,
        schedulingMeeting: state.schedule.schedulingMeetings,
        scheduledMeeting: state.schedule.scheduledMeeting,
        existingMode: state.schedule.existingMode,
        gendersMap: state.schedule.itemsGenderMap,
        quantityMap: state.schedule.itemsQuantityMap,
        daysOfWork: state.schedule.daysOfWork,
        waitingListMode: state.schedule.waitingListMode,
        waitingListRangeType: state.schedule.waitingListRangeType,
        waitingListSelectedDate: state.schedule.waitingListSelectedDate,
        waitingListSelectedDaysOfWeek: state.schedule.waitingListSelectedDaysOfWeek,
        // This
        registeringWaitingList: state.schedule.registeringWaitingList,
        registeringWaitingListError: state.schedule.registeringWaitingListError,
        waitingListItem: state.schedule.waitingListItem,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getOptions: (token, serviceIds, employeeId, dayPart, date, loadMore = false, existingMode, genderMap, quantityMap) =>
            dispatch(getSpecificOptions(token, serviceIds, employeeId, dayPart, date, loadMore, existingMode, genderMap, quantityMap)),
        toggleDayPart: (option) => dispatch(toggleDayPart(option)),
        resetWizard: () => dispatch(resetWizard()),
        // Make usage of waiting list plain setters
        setWaitingListRangeType: (rangeType) => dispatch({type: 'SET_WAITING_LIST_RANGE_TYPE', rangeType}),
        setWaitingListSelectedDate: (selectedDate) => dispatch({type: 'SET_WAITING_LIST_SELECTED_DATE', selectedDate}),
        setWaitingListSelectedDaysOfWeek: (daysOfWeek) => dispatch({
            type: 'SET_WAITING_LIST_SELECTED_DAYS_OF_WEEK',
            daysOfWeek
        }),
        registerWaitingList: (waitingListOptions, cb) => dispatch(registerWaitingListItem(waitingListOptions, cb)),


    }
};


export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ResultsPage));
